import { render, staticRenderFns } from "./NotificationGeneral.vue?vue&type=template&id=4c9eb666&scoped=true&"
import script from "./NotificationGeneral.vue?vue&type=script&lang=js&"
export * from "./NotificationGeneral.vue?vue&type=script&lang=js&"
import style0 from "./NotificationGeneral.vue?vue&type=style&index=0&id=4c9eb666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9eb666",
  null
  
)

export default component.exports